const TRANSLATION = {
  buyModal: {
    afterFree: 'לאחר הניסוי החינם שלך',
    btn: 'נסו בחינם',
    freeTrial: 'ניסוי חינם למשך 3 ימים',
    monthLabel: 'חודש',
    selectLabel: 'בחר תוכנית',
    title: 'תוכנית מנוי',
    yearLabel: 'שנה',
  },
  contact: {
    block1:
      'להתאמות אישיות, שאלות או הצעות, אנא צרו קשר μαζίינו ב- contact@noam.tools. נענה בזמן מה.',
    block2: ' תמכו בנו על ידי ציון בחנו בחנות הרחבות Google Apps עם ★★★★★.',
    block3: 'עזור לאחרים על ידי שיתוף התוסף הזה:',
    title: 'צור קשר',
  },
  help: {
    AquickOverviewOfNoam: 'סקירה מהירה של נועם',
    ChatPDF: "צ'אט PDF",
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'ניהול מועדפים',
    Fixedplugin: 'פלגין מתוקן',
    Focusing: 'התמקדות',
    Free: 'חינם',
    FreeTrialBenefits: 'יתרונות ניסיון חינם',
    GoWithWikipedia: 'עבור עם ויקיפדיה',
    GoWithYouTube: 'עבור עם YouTube',
    HoverTranslation: 'תרגום ריחוף',
    Howtouse: 'איך להשתמש',
    ImageTranslation: 'תרגום תמונה',
    InstantTranslation: 'תרגום מיידי',
    Membership: 'חברות',
    NoamHelp: 'נועם עוזר לך לתרגם ולסיכום',
    PDFparallelTranslation: 'תרגום מקביל של PDF',
    ParallelTranslation: 'תרגום מקביל',
    SkipAllSteps: 'דלג על כל השלבים',
    Summary: 'סיכום',
    Translation: 'תרגום',
    TryItForFree: 'נסו בחינם',
    Video: 'וידאו',
    VideoSummary: 'סיכום וידאו',
    VideoTranslation: 'תרגום וידאו',
    WebSummary: 'סיכום אתר אינטרנט',
    WordSelectionTranslation: 'תרגום בחירת מילים',
    benefits: 'יש לנו הטבות המחכות לך!',
    dayFree: 'ניסיון חינם של 3 ימים',
    done: 'בוצע',
    next: 'הבא',
    pin: 'צבע את נועם לגישה קלה יותר～～',
    planIsNotExist: 'התוכנית אינה זמינה',
    startWiki: 'בואו נתחיל עם ויקימדיה!',
    startYoutube: 'בואו נתחיל עם YouTube!',
    try: 'נסו את זה',
    tryNow: 'נסו את זה עכשיו!',
  },
  home: {
    PDFTranslate: {
      desc: "תרגום דו-לשוני + צ'אט PDF",
      sub1: {
        desc: 'קריאה דו-לשונית מאפשרת לך להשוות בין הטקסט המקורי לתרגום זה לצד זה, מה שמשפר את יעילות הקריאה.',
        title: 'קריאה דו-לשונית',
      },
      sub2: {
        desc: 'ה-AI מנתח ומסירט, ויכול לענות על השאלות שלך על סמך תוכן ה-PDF.',
        title: "צ'אט PDF",
      },
      sub3: {
        desc: 'תרגום PDF מונע על ידי AI להקמת דיוק ויעילות גבוהים יותר.',
        title: 'דיוק ויעילות',
      },
      title: 'תרגום PDF',
    },
    aiAssistant: {
      desc: 'הפעלת תרגום אינטרנט חכם ונוח יותר',
      panel1: {
        desc: 'תרגומים דו-לשוניים עם התייחסות מקושרת עוזרים לך להשוות את הטקסט המקורי עם התרגום, כך שתוכל להבין טוב יותר ולשפר את יעילות הקריאה שלך.',
        title: 'תרגום דו-לשוני',
      },
      panel2: {
        left: {
          desc: 'כאשר מגלילים בדף אינטרנט, עשה ריחוף מעל התוכן שצריך לתרגם כדי לראות את התרגום.',
          title: 'תרגום מעוף',
        },
        right: {
          desc: 'כאשר מגלילים בדף אינטרנט, בחרו את הטקסט שברצונכם לתרגם כדי לראות את התרגום.',
          title: 'תרגום בחירת טקסט',
        },
      },
      panel3: {
        one: {
          desc: 'תרגם וסיכום דפי אינטרנט ותוכן וידאו בכל עת ובכל מקום, לחוויה חלקה יותר!',
          title: 'נקד וקליק',
        },
        three: {
          desc: 'מודל שפה גדול מונע על ידי AI гарантирует דיוק ועקביות בתרגום לחווית קריאה משופרת.',
          title: 'מונע על ידי AI',
        },
        two: {
          desc: 'כיסוי מלא במיקומים מרובים, קריאה דו-לשונית ללא حواجز, תרגום בקיצור אחת - חווית את ההבדל!',
          title: 'מקיף ונוח יותר',
        },
      },
      panel4: {
        tab1: {
          desc: 'מומח היעילות שלך - באמצעות ChatGPT, נועם מתרגם ומסיכום תוכן וידאו ב-YouTube כדי לחסוך לך זמן!',
          key: 'וידאו',
          title: 'תרגום וסיכום וידאו',
        },
        tab2: {
          desc: 'לחץ כדי לתרגם תמונות בזמן גלישה באינטרנט.',
          key: 'תמונה',
          title: 'תרגום תמונה',
        },
        tab3: {
          desc: 'מחלץ מיד מידע מפתח מדפי אינטרנט ומספק תקציר, משפר את יעילות הקריאה שלך.',
          key: 'וובס',
          title: 'תרגום וסיכום אינטרנטי',
        },
        tag1: 'פשוט',
        tag2: 'יעיל',
        tag3: 'קל להבנה',
      },
      title: 'עזר AI',
    },
    getStart: 'התחל',
    getStartedForFree: 'התחל бесплатно',
    howItWork: {
      desc: 'נועם משלבת מודלים של בינה מלאכותית כדי לספק למשתמשים חוויה אינטליגנטית לתרגום וסיכום דפי אינטרנט בין שפות, תרגום PDF ותמונות, תרגום וסיכום וידאו',
      title: 'איך זה עובד',
    },
    lastBlock: { desc: 'תרגום AI טוב יותר לחווית קריאה חלקה יותר' },
    top: {
      desc: 'נועם היא הרחבת דפדפן AI חינכית שעוזרת לך לתרגם ולסיכום דפי אינטרנט, סרטונים ותוכן PDF.\n      הצטרפו לנועם וחוו את הקוסמה!',
      title1: 'אחת מגיתית',
      title2: 'לחיצה אחת',
    },
    userReviews: { desc: "ביקורות בד' כוכבים בחנות ה-Web של Chrome", title: 'ביקורות משתמשים' },
  },
  installTips: {
    btn: 'נסו עכשיו',
    text: 'התקן את "תוסף דפדפן נועם" כדי לפתוח תכונות נוספות! צימתות מרובות באינטרנט,\n    סיכום וידאו מאינטרנט ועוד רבות!',
  },
  locale: {
    af: 'אפריקאנס',
    am: 'אמהרית',
    ar: 'ערבי',
    as: 'אסאמית',
    auto: 'זיהוי אוטומטי',
    az: "אזרבג'אני",
    ba: 'בשקירי',
    bg: 'בולגרי',
    bn: 'בנגלית',
    bo: 'טיבטני',
    bs: 'בוסני',
    ca: 'קטלני',
    cs: "צ'כ",
    cy: 'וולשי',
    da: 'דני',
    de: 'גרמני',
    dsb: 'סורבי תחתון',
    dv: 'דיבהי',
    el: 'יווני',
    en: 'אנגלית',
    es: 'ספרדי',
    et: 'אסטוני',
    eu: 'בסקי',
    fa: 'פרסי',
    fi: 'פיני',
    fil: 'פיליפיני',
    fj: "פיג'י",
    fr: 'צרפתי',
    frCA: 'צרפתית ( קנדה )',
    ga: 'אירי',
    gl: 'גליציאני',
    gom: 'קונקני',
    gu: "גוג'ראטי",
    ha: 'האוסה',
    he: 'עברית',
    hi: 'הינדי',
    hr: 'קרואטי',
    hsb: 'סאורבי עליון',
    ht: 'קריאול הייטי',
    hu: 'הונגרי',
    hy: 'ארמני',
    id: 'אינדונזי',
    ig: 'איגבו',
    ikt: 'אינוינאקטון',
    is: 'איסלנדי',
    it: 'איטלקי',
    iu: 'אינוקטיטוט',
    iuLatn: 'אינוקטיטוט (לטיני)',
    ja: 'יפני',
    ka: 'גיאורגי',
    kk: 'קזחי',
    km: 'חמרי',
    kmr: 'קורדי (צפון)',
    kn: 'كانнада',
    ko: 'קוריאני',
    ku: 'קורדי (מרכזי)',
    ky: 'קירוגיזי',
    ln: 'לינגלה',
    lo: 'લાઓ',
    lt: 'ליטאָני',
    lug: 'גנדה',
    lv: 'לטבי',
    lzh: 'סינית (ספרותית)',
    mai: 'מאיתילי',
    mg: 'מלגזי',
    mi: 'מאורי',
    mk: 'מקדוני',
    ml: 'מלאיאלאם',
    mnCyrl: 'מונגולי (צירילי)',
    mnMong: 'מונגולי (מסורתית)',
    mr: 'מרטה',
    ms: 'מלזי',
    mt: 'מלטזי',
    mww: 'המונג דאו',
    my: 'מיאנמר (בורמני)',
    nb: 'נורבגי',
    ne: 'נפאלי',
    nl: 'הולנדי',
    noSearchLang: 'שפה לא נתמכת',
    nso: 'ססוטו סא לבואה',
    nya: "ניאנג'ה",
    or: 'ओडिया',
    otq: 'אוטומי קרטהרוס',
    pa: "פונג'abi",
    pl: 'פולני',
    placeholder: 'חיפוש',
    prs: 'דארי',
    ps: 'פשטו',
    pt: 'פורטוגזית (ברזיל)',
    ptPT: 'פורטוגזית (פורטוגל)',
    ro: 'רומני',
    ru: 'רוסי',
    run: 'רונדי',
    rw: 'קיניארוונדה',
    sd: 'סינדי',
    si: 'סינהלה',
    sk: 'סלובקי',
    sl: 'סלובני',
    sm: 'סמואני',
    sn: 'שונה',
    so: 'סומלי',
    sq: 'אלבני',
    srCyrl: 'סרבי (צירילי)',
    srLatn: 'סרבי (לטיני)',
    st: 'ססוטו',
    sv: 'שוודית',
    sw: 'סוואהילי',
    ta: 'טמיל',
    te: 'טלוגו',
    th: 'תאילנדי',
    ti: 'טיגריניה',
    tk: 'טורקמני',
    tlhLatn: 'קלינגון',
    tlhPiqd: 'קלינגון (פיקאד)',
    tn: 'סטסוואנה',
    to: 'תווגני',
    tr: 'טורקי',
    tt: 'טטארי',
    ty: 'טהיטי',
    ug: 'אוייגר',
    uk: 'אוקראיני',
    ur: 'אורדו',
    uz: 'אוזבקי (לטיני)',
    vi: 'וייטנאמי',
    xh: 'חוסה',
    yo: 'יורובה',
    yua: 'מאיה יוקאטק',
    yue: 'קנטונזי (מסורתי)',
    zh: 'סיני',
    zhHans: 'סינית פשוטה',
    zhHant: 'סינית מסורתית',
    zu: 'זולו',
  },
  login: {
    and: 'וגם',
    btn: 'התחבר עם גוגל',
    btn1: 'התחבר כעת',
    desc: 'היכנס כדי לפתוח נגישות לחוויות נוספות',
    policy: 'מדיניות פרטיות',
    terms: 'תנאי שימוש',
    tips: 'בהרשמה, אני מסכים ל',
    title: 'ברוכים הבאים לנועם',
  },
  pageFooter: {
    follow: { facebook: 'פייסבוק', title: 'עקוב', twitter: 'טוויטר' },
    legal: { policy: 'מדיניות פרטיות', terms: 'תנאי השירות', title: 'חוקי' },
    product: {
      image: 'תרגום תמונה',
      pdf: 'תרגום PDF',
      title: 'מוצרים',
      video: 'תרגום וסיכום וידאו',
      web: 'תרגום וסיכום מקוונים',
    },
    resources: { title: 'משאבים' },
    tools: { title: 'כלי', pdf: 'תרגום PDF' },
  },
  pageHeader: {
    contact: 'צור קשר',
    help: 'עזרה',
    logout: 'התנתקות',
    logoutSucc: 'התנתקת.',
    pricing: 'מחירים',
    settings: 'הגדרות',
    signUp: 'התחבר',
  },
  pdf: {
    autoDetect: 'זיהוי אוטומטי',
    cancelBtn: 'בטל',
    cancelUpload: 'בטל',
    chatPdf: {
      summaryError: 'סיכום נכשל, נא לנסות שוב מאוחר יותר',
      chatError: 'הצאט נכשל, נא לנסות שוב מאוחר יותר',
      Search: 'חיפוש',
      cancel: 'בטל',
      chatTitle: 'ברוכים הבאים לנועם! הנה סיכום של ה-PDF שלך:',
      clear: 'ברור',
      clearContent: 'זה יתחיל שיחה חדשה. השיחה הנוכחית לא תישמר. אתה בטוח?',
      clearDialogTitle: 'נא לאשר',
      clearSucc: 'נמחק',
      copy: 'העתק',
      copySucc: 'הועתק',
      delete: 'מחק',
      deleteCancel: 'בטל',
      deleteContent: 'לא ניתן לשחזר את ה-PDF הזה לאחר מחיקתו. אתה בטוח?',
      deleteOk: 'מחק',
      deleteSuccess: 'מחוק',
      deleteTitle: 'אישור מחיקה',
      expand: 'קריסה',
      historyTitle: 'היסטוריה',
      listError: 'נכשל לטעון רשימת קריאה. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
      loading: 'טוען...',
      noDataDesc: 'עוד אין היסטוריה.',
      noMore: 'אין יותר תוכן.',
      placeholder: 'שאל כל מה לגבי ה-PDF הזה',
      summaryTitle: 'אולי תעניין אותך השאלות הללו:',
    },
    collectionEmpty: 'האוסף שלך ריק.',
    collectionTab: 'הערות',
    dataLoading: 'טוען...',
    dialogContent: 'האם אתה בטוח שברצונך למחוק את זה?',
    dialogTitle: 'אנא אשר',
    download: {
      both: 'דוֹבְנִי',
      btn: 'שמור',
      cancel: 'סגירת חלון זה תבטל את הורדת ה-PDF. האם אתה בטוח שברצונך לבטל?',
      desc: 'שמור למכשיר: הורד תרגומים כתמונות; שמור והדפס: הורד תרגומים בפורמט המקורי, עם תמיכה בהעתקה.',
      download: 'הורדה',
      downloadMsg1: 'התקדמות תרגום PDF:',
      downloadMsg2: 'זמן שנותר משוער:',
      downloadSucc: 'ה-PDF מוכן! לחץ כדי לשמור.',
      downloadTip:
        'מְתַאַרְגִים פְּסְפְּס. אַל תִּסגֵר אֶת הַפֶּנֶה הַזֶּה כְּדֵי לְהִתְהַלֵּךְ מִשּׁוּגִים בְּהַתְמָן',
      error: 'נכשל בשמירה. נסה להדפיס במקום זאת.',
      fileName: 'שם הקובץ:',
      fileType: 'סוג הקובץ:',
      loading: 'משמר...',
      loading2: 'טוען...',
      minute: 'דקות...',
      msg1: 'חלק מהתרגומים במסמך זה ארוכים יותר מהטקסט המקורי, ועשויים לחפוף בקובץ הורד. אנו ממליצים לקרוא בדף האינטרנט.',
      msg2: 'התרגום עדיין לא הושלם. אנא הורד לאחר השלמת התרגום.',
      msg3: '2. חלק מהתרגומים ממושכים מדי. קראו בדף האינטרנט כדי למנוע חפיפה של טקסט.',
      msg4: 'משימות תרגום בעיבוד. נא לנסות שוב לאחר השלמתן.',
      progress: 'מתעביר PDF. התקדמות: {{progress}}, זמן שנותר משוער: {{minutes}} דקות...',
      save: 'שמור למכשיר',
      savePrint: 'שמור והדפס',
      success: 'הורד',
      trans: 'תרגום בלבד',
      transContinue: 'המשך לתרגם',
    },
    downloadBtn: 'הורדה',
    dragTipModal: {
      black: 'מרחב',
      leftKey: 'כפתור שמאלי',
      ok: 'אוקיי',
      press: 'לחץ',
      tips: 'לגרור ולהציג',
    },
    entry: 'PDFs',
    fileErrMsg: 'קריאת הקובץ נכשלה. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    fileMsg: 'גודל הקובץ הנוכחי:',
    fileMsg2: 'נא להעלות קובץ בגודל קטן מ-300MB.',
    freeBannerBtn: 'שדרוג',
    freeBannerTips: 'גבול תרגומי PDF חינם הושג',
    guide: {
      placeholder: 'הדבק את קישור ה-PDF כאן',
      start: 'התחל לתרגם',
      text1: 'קריאה דו-לשונית',
      text2:
        'קראו בצורה דו-לשונית כדי להשוות את הטקסט המקורי ואת התרגום זה לצד זה, ולשפר את היעילות שלכם.',
      text3: 'שיחה עם ה-PDF שלך',
      text4: 'ניתוח וסיכום ממונעים על ידי AI. השאירו שאלות על ה-PDF שלכם, וקבלו תשובות מיידיות.',
      text5: 'מדויק ומועיל',
      text6: 'תרגום PDF מופעל על ידי AI להצגת דיוק ויעילות גבוהים יותר.',
      title1: 'תרגום דו-לשוני',
      title2: 'שיחה עם ה-PDF שלך',
      toast: 'אנא הכנס קישור PDF מקוון תקף המסתיים ב-.pdf',
    },
    hasTransTask: 'משימת תרגום בעיצומה. נא להמתין.',
    hoverTrans: 'פסקאות להקדמות לתרגום',
    initial: 'תרגם PDF',
    installText: 'הפתרון המלא שלך לתרגומים יומיים.',
    installText2: 'נא להתקין את התוסף תחילה',
    installTips: 'התקן את ההרחבה עבור עוד תרגומי PDF ותרגומי אתרים חלקים יותר:',
    kw: 'סיכום',
    link: 'קישור',
    listError: 'טעינת ה-PDF נכשלה. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    memoTotalCount: 'סך הכל 1 פריט',
    new: 'קובץ חדש',
    noId: 'מזהה קובץ לא נמצא.',
    notPdf: 'רק קבצי PDF.',
    okBtn: 'מחק',
    okBtn2: 'הבנתי',
    original: 'מקורי',
    parallel: 'מקביל',
    parseErrDialogContent:
      'קישור ה-PDF הזה לא ניתן לתרגום ישירות. אנא הורד את ה-PDF והעלה אותו לתרגום.',
    parseErrTips: 'נכשל בפירוש הקובץ',
    parseFileToast: 'נכשל בניתוח הקובץ. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    pdfLoading: 'מנתח...',
    searchPlaceholder: 'חיפוש',
    selectTrans: 'בחר טקסט לתרגום',
    shareBtn: 'שתף',
    shareBtnText1: 'צור קישור שיתוף',
    shareBtnText2: 'עדכן תוכן משותף',
    shareModal: {
      cancel: 'בטל',
      copy: 'העתק',
      copySucc: 'קישור הועתק',
      custom: 'תאמה אישית:',
      errMsg: 'התוכן הנבחר עדיין לא תורגם במלואם. נא לתרגם לפני השיתוף.',
      gen: 'שתף',
      modify: 'עריכה',
      notSupport: 'שפה זו אינה נתמכת כעת.',
      page: 'עמודים',
      pageNuErr: 'אנא הכנס מספר עמוד חוקי.',
      range: 'היקף:',
      remain: 'נותר',
      remain1: 'זמן משוער כולל:',
      search: 'חיפוש',
      settings: 'הגדרות שיתוף:',
      shareSetting: 'הגדרות שיתוף',
      shareText: 'שתף',
      shareTips: 'שתפו את קישור ה-PDF המתורגם עם חבריכם:',
      sourceLang: 'מאת:',
      target: 'ל: ',
      text1: 'הגדרות שיתוף',
      text2: 'צור קישור שיתוף',
      totalPage: 'סך הכל 1 עמוד',
      trans: 'תרגם',
      translateTips: 'טיפ: אם התרגום לוקח זמן, תוכל לסגור את החלון הזה ולשתף αργότερα.',
      translating: 'מתפרש PDF...',
      update: 'עדכן קישור שיתוף',
    },
    shareMsg1: 'קישור שיתוף נוצר.',
    shareMsg2: 'תוכן משותף עודכן.',
    shareMsg3: 'נכשל ליצור קישור שיתוף. נא לנסות שוב מאוחר יותר או לפנות לשירות התמיכה.',
    shareMsg4: 'נכשל בעידכון התוכן המשותף. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    shareTips: 'תרגום ה-PDF שלך מוכן! שתפו אותו עם חבריכם.',
    start: 'התחל בניסיון חינם',
    thumbnail: 'תוכן העניינים',
    toast1: 'טוען PDF. נא לנסות שוב מאוחר יותר.',
    toast2: 'תוכן ה-PDF מעובד כעת. דו-שיח אינו נתמך כרגע.',
    toast3: 'מוריד. נא לנסות שוב לאחר השלמת הורדה.',
    toolbar: { Adjust: 'כוונן', autoFit: 'סביבה אוטומטית' },
    trans: 'תרגום',
    transSucc: 'התרגום הצליח!',
    unLoginToast: 'נא להתחבר כדי להשתמש בפונקציה זו.',
    uploadBtn: 'העלאה',
    uploadErr: 'העלאת הקובץ נכשלה. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    uploadErrSignUrl: 'לא ניתן היה לקבל כתובת URL להעלאה. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    uploadMsg1: 'גרור את הקובץ שלך לכאן ושחרר.',
    uploadMsg2: 'סוגי קבצים נתמכים: PDF  |  גודל מקסימלי של קובץ: 300MB',
    uploadMsg3: 'לחץ לבחירה או גרר ושחרר קבצים כאן.',
    uploading: 'מעלה',
    uploadingMsg: 'מעלה. נא להמתין.',
    uploadingMsg1: 'הקובץ מתעלה. נא לנסות שוב מאוחר יותר.',
    uploadingMsg2: 'קובץ נמרה כרגע. נא לנסות שוב מאוחר יותר.',
    uploadingMsg3: 'בקשת התקדמות המרה נכשלה. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    uploadingMsg4: 'נועם לא יכול לגשת לקובצי מקומיים. נא להעלות ידנית PDF לתרגום.',
    uploadingMsg5: 'נכשל בקבלת כתובת URL של הקובץ. נא לנסות שוב מאוחר יותר או לפנות לתמיכה.',
    video: 'וידאו',
    vipBannerBtn: 'שדרוג',
    vipBannerTips: 'הגעתם למגבלת תרגום PDF שלכם לחודש זה.',
    webTrans: 'סיכום מלא של הקישורים הדדיים',
  },
  pricing: {
    FAQ: 'שאלות ותשובות נפוצות',
    FQAObj: {
      a1: 'כן, נועם מציע תוכנית חינכית שתוכל להשתמש בה מיד.',
      a2: 'אנחנו מציעים שלושה תוכניות חברות: פרו, פרו+ וענטפראייז. אתה יכול לבחור לשלם חודשי או שנתי. חשבונית שנתית מציעה חיסכון משמעותי.',
      a3: 'כל התכונות זמינות בשני התוכניות. ההבדל העיקרי הוא העלות: מנויים שנתיים עומדים בעלות נמוכה יותר בסך הכל. מנויים חודשיים מחוקרים מדי חודש, בעוד שתוכניות שנתיות מחוקרות פעם בשנה.',
      a4: 'אתה יכול לבטל את המנוי שלך בכל עת במגדרות החשבון שלך.',
      q1: 'האם יש תוכנית חינמית?',
      q2: 'אילו תוכניות מחירים אפשרויות ואופציות תשלום קיימות?',
      q3: 'מה ההבדל בין הרשמה חודשית לניכרת שנתית?',
      q4: 'איך אני מבטל את המנוי שלי?',
    },
    around: 'מסביב',
    billedMonthly: 'חשבונית חודשית',
    billedYearly: 'חשבונית שנתית',
    day: 'יום',
    desc: 'השווה תוכניות והבחר את הטובה ביותר',
    detailedCompare: 'השוואת תוכניות',
    discount: '20% הנחה',
    enterprise: {
      benefit1: 'תמיכה ללקוחות בעלות עדיפויות',
      benefit2: 'משתמשים מרובים',
      benefit3: 'פתרונות מותאמים אישית',
      benefit5: 'מנהל חשבון ייעודי',
      btn: 'צור קשר',
      recommendText: 'תוכניות מותאמות אישית (≥3 أشخاص)',
      talkToUs: 'צור קשר',
    },
    free: {
      benefit1: 'תרגום מיידי 100 פעמים ביום',
      benefit2: 'תרגום וסיכום אתר אינטרנט',
      benefit3: '30 תרגומי תמונה',
      benefit4: 'תרגום וסיכום וידאו',
      benefit5: '10 תרגומים PDF',
      benefit6: '5,000 טוקנים',
      btn: 'נסו בחינם',
      recommendText: 'ניסיון חינם',
    },
    imageTranslation: 'תרגום תמונה',
    month: 'חודש',
    monthly: 'חודשי',
    pageTitle: 'מחירון',
    pdf: { chat: "שאילתות צ'אט ל-PDF", maxPage: 'מקסימום. דפים לכל PDF', translation: 'תרגום PDF' },
    preMonth: 'בחודש',
    pro: {
      benefit1: 'תמיכה לקוחות עדיפוית',
      benefit2: '1,000,000 טוקנים לחודש',
      benefit3: 'תרגום וסיכום אתר אינטרנט',
      benefit4: '200 תרגומי תמונה',
      benefit5: 'תרגום וסיכום וידאו',
      benefit6: '200 תרגומי PDF',
      btn: 'התחל',
      recommendText: 'הפופולריים ביותר',
    },
    proPlus: {
      benefit1: 'תמיכה לקוחות עדיפוית',
      benefit2: '3,000,000 טוקנים בחודש',
      benefit3: 'תרגום וסיכום אתר אינטרנט',
      benefit4: '500 תרגומי תמונות',
      benefit5: 'תרגום וסיכום וידאו',
      benefit6: '500 תרגומי PDF',
      recommendText: 'ערך מעולה',
    },
    video: { summary: 'סיכום וידאו', translation: 'תרגום וידאו' },
    web: {
      contrastiveTranslation: 'תרגום דו-לשוני',
      dictionaryTranslation: 'תרגום בחירה',
      hoverTranslation: 'תרגום ריחף',
      instantTranslation: 'תרגום מיידי',
      summary: 'סיכום דף אינטרנט',
    },
    yearly: 'שנתי',
  },
  privacy: {
    block1:
      'נועם ("נועם", "אנחנו", "המערכת שלנו" או "לנו") מכבד את פרטיותך ומחויבת להגן על כל מידע שאנחנו מקבלים ממך או אודותיך. מדיניות פרטיות זו מתארת את நடைமுறותינו לגבי אוסף או שימוש במידע אישי משימושך באתר האינטרנט, האפליקציות והשירותים שלנו (בהצגה קולקטיבית, ה-"שירותים"). מדיניות פרטיות זו לא חלה על התוכן שאנחנו מטפלים בו במשך לקוחות מוצרים עסקיים שלנו, כמו ה-API שלנו. שימוש בנתונים אלו תלוי במסגרת הסכמה עם הלקוח שלנו, המכסה גישה ושימוש במוצרים אלו.',
    block10:
      'אנחנו מפעילים אמצעים טכניים, מנהלים וארגוןיים סבירים מבחינה מסחרית כדי להגן על מידע אישי מקווני ולא מקווני מפני אובדן, שימוש לרעה, גישה לא מורשית, חשיפה, שינוי או פעולות עוינות. עם זאת, אף שידור אינטרנט או דואר אלקטרוני לא יכול להבטיח אבטחה או דיוק מלאים. בפרט, דואר אלקטרוני הנשלח אלינו או משלחים אליו עשוי לא להיות מאובטח. לכן, עליך להקפיד במיוחד בעת החלטה מה המידע לשלוח אלינו דרך השירות או הדואר אלקטרוני. בנוסף, אנחנו לא אחראים לכל עיכוב בהגדרות פרטיות או אמצעי אבטחה בשירות או בהגדרות אבטחה או אמצעי אבטחה של אתרים של צדדים שלישיים. אנו תשמור על המידע האישי שלך כל עודจำเป็น כדי לספק לך שירותים או למטרות עסקיות חוקיות אחרות, כגון פתרון מחלוקות, סיבות אבטחה ובטיחות, או עמידה בחובותינו החוקיות. משך הזמן שבו אנו שומרים על המידע האישי יתלו בגורמים רבים, כמו כמות, אופי, רגישות המידע, הסיכונים הפוטנציאליים של שימוש לא מורשית או חשיפה, המטרות עבור яких אנו מעבדים את המידע, ושיקולי אחרים מחייבים חוקית.',
    block11:
      'יתכן שנעדכן את מדיניות הפרטיות הזו מעת לעת. ככל שנעשה זאת, נפרסם גרסה מעודכנת בדף זה, אלא אם חוק רלוונטי דורש אחרת.',
    block12:
      'אם יש לך שאלות לא משובבות או חששות לגבי מדיניות פרטיות זו, אנא צור קשר עם שירות הלקוחות שלנו. אימייל:',
    block2: 'אנחנו אוספים את המידע האישי הבא ("מידע אישי") המשויך אליך:',
    block3:
      'מידע שסיפקת: כשה אתה יוצר חשבון כדי להשתמש בשירותינו או לתקשר איתנו, אנו אוספים מידע אישי כדלקמן:',
    block4:
      'מידע אישי המתקבל אוטומטית משמוש בשירותים: כאשר אתהzugriff, משתמש או מקיים אינטראקציה עם השירותים, אנו מקבלים את המידע הבא על הגישה, השימוש או האינטראקציה שלך ("מידע טכני"):',
    block5: 'עשויים להשתמש במידע אישי למטרות הבאות:',
    block6:
      'סיכום או מידע ללא זיהוי: נוכל להצטבר או להסיר את הזיהוי של מידע אישי כדי למנוע שימוש חוזר בו למטרות זיהוי ולהשתמש במידע זה כדי לנתח את היעילות של השירותים שלנו, לשפר ולשנות תכונות בשירותים שלנו, לבצע מחקר ועבור מטרות דומות. בנוסף, נוכל לנתח את ההתנהגות הכללית והמאפיינים של משתמשי השירות שלנו ולשתף מידע מקובץ עם גורמים שלישיים, לפרסם מידע מקובץ כזה או להפוך אותו לזמין באופן כללי. נוכל לאסוף מידע מקובץ דרך השירותים, דרך קוקיז ודרך אמצעים אחרים המתוארים בחוזה הזה על פרטיות. נוכל לשמור ולהשתמש במידע ללא זיהוי בצורה אנונימית או ללא זיהוי, ולא נוכל לנסות לזהות מחדש מידע כזה אלא אם נדרש על פי חוק.',
    block7:
      'במקרים מסוימים, قد نوفر את המידע האישי שלך לצדדים שלישיים ללא הודעה נוספת לך, אלא אם כן נדרש על פי חוק:',
    block8:
      'בהתאם למיקומך הגיאוגרפי, אנשים באזור הכלכלי האירופי, בבריטניה ובעולם כולו עשויים להיות זכויות סטטוטוריות מסוימות לגבי המידע האישי שלהם. לדוגמה, ייתכן שיש לך את הזכות ל:',
    block9:
      'השירות עשוי להכיל קישורים לאתרים אחרים שאינם מנוהלים או נשלטים על ידי נועם, כולל שירותי מדיה חברתית ("אתרים של צדדים שלישיים"). המידע שתשתפו עם אתרים של צדדים שלישיים ישלט על ידי מדיניות הפרטיות הספציפיות ותנאי השירות של אתרים הצדדים השלישיים, לא על ידי מדיניות הפרטיות هذه. אנו מספקים קישורים אלו למטרות נוחות ואינן משמעות שיקורנו או בדיעתנו של אתרים אלו. אנא פנה ישירות לאתרים של צדדים שלישיים לקבלת מידע על מדיניות הפרטיות והתנאים שלהם.',
    subBlock1:
      'מידע חשבון: כאשר אתה יוצר חשבון בפלטפורמה שלנו, אנו אוספים מידע הקשור לחשבונך, כולל שמך, פרטי επικοινωνיה, פרטי גישה לחשבון, מידע על כרטיס תשלום והיסטוריית עסקאות ("מידע חשבון").',
    subBlock10: 'סיפקה, ניהול, תחזוקה ו/או ניתוח שירותים;',
    subBlock11: 'תקשורת איתך',
    subBlock12: 'פיתוח מוצרים ושירותים חדשים;',
    subBlock13:
      'מניעת הונאה, פעילות פלילית או שימוש לא תקין בשירותינו, והגנה על אבטחת מערכות ה-IT, הארכיטקטורה והרשתות שלנו;',
    subBlock14: 'ביצוע העברות עסקיות;',
    subBlock15:
      'ציות לחובות משפטיים ולימודי משפטיים, הגנה על זכויותינו, פרטיותנו, בטיחוננו או רכושנו, כמו גם על אלו של חברות השייכות שלנו, שלך או של גורמים שלישיים אחרים.',
    subBlock16:
      "ספקים וספקי שירותים: כדי לעזור לנו לעמוד בצרכים תפעוליים עסקיים ולבצע שירותים ופונקציות מסוימים, נוכל לספק מידע אישי לספקים וספקי שירותים, כולל ספקי שירותי φιרישה, ספקי שירותי ענן, וספקי שירותי טכנולוגיית מידע אחרים, תוכנת תקשורת דואר אלקטרוני, ספקי שירותי ניתוח אתרים, וכו'. שותפים אלו יחברו, יעבדו או ישמרו מידע אישי רק בהנחיותינו בזמן ביצוע תפקידיהם עבורנו.",
    subBlock17:
      'העברות עסקיות: אם נעשה שימוש בטרנזקציות אסטרטגיות, ארגון מחדש, הרשמות לפשיטה, קבלת השתלטות בנסיבות פשיטה או המעבר של שירותים לספק אחר (בהחלטה, "טרנזקציות"), המידע האישי שלך ומידע אחר עשויים להיות משותפים עם עברי הטרנזקציה וצדדים אחרים המסייעים בטרנזקציות במהלך בדיקת השתתפות ויועברו כחלק מהטרנזקציות יחד עם נכסים אחרים לחברה עוקבת או משותפת.',
    subBlock18:
      'דרישות משפטיות: قد نشارك את המידע האישי שלך עם רשויות ממשלתיות, עמיתים בתעשייה או גורמים שלישיים אחרים, לרבות מידע על אינטראקציות שלך עם השירותים שלנו, (1) אם נדרש על פי חוק או אם אנו מאמינים שפעולה זו נחוצה כדי לעמוד בחובות משפטיות; (2) כדי להגן על זכויותינו או רכושנו ולהגבירם; (3) אם אנו קובעים באופן חד-צדדי שיש הפרה של תנאים, מדיניות או חוקים שלנו; (4) כדי לזהות או למנוע הונאה או פעילויות לא חוקיות אחרות; (5) כדי להגן על מוצרים, עובדים או משתמשים שלנו, או על בטיחות ציבורית, אבטחה, שלמות; או (6) כדי להגביל אחריות משפטית.',
    subBlock19: 'גישה למידע אישי שלך ומידע על אופן עיבודו.',
    subBlock2:
      'כאשר אתה משתמש בשירותים שלנו, אנו אוספים מידע אישי מהקלטים שלך, העלאות קבצים או משוב שניתן לנו ("תוכן").',
    subBlock20: 'בקשה למחיקת הפרטים האישיים שלך מהרשומות שלנו.',
    subBlock21: 'תקן או עדכן את הפרטים האישיים שלך.',
    subBlock22: 'העברת מידע אישי שלך לצד שלישי (ניידות נתונים).',
    subBlock23: 'הגביל כיצד אנו מעבדים את המידע האישי שלך.',
    subBlock24:
      'בטל את הסכמתך — במיקומים בהם אנו מסתמכים על הסכמה כהסבר משפטי לעבוד עם המידע, אתה יכול לבטל את הסכמתך בכל עת.',
    subBlock25: 'התנגדות לאופן שבו אנו מטפלים במידע הפרטי שלך.',
    subBlock26: 'שיפור השירותים שלנו וביצוע מחקר;',
    subBlock3:
      'מידע תקשורתי: אם תשלחו לנו הודעות, נאסף את שמך, פרטי התקשורת שלך ותוכן ההודעות שלך („מידע תקשורתי“).',
    subBlock4:
      'מידע רשתות חברתיות: יש לנו דפים ברשתות חברתיות כמו אינסטגרם, פייסבוק, מדיום, טוויטר, יוטיוב ולינקדאין.כאשר אתה מקיים אינטראקציה עם הדפים החברתיים שלנו, אנו אוספים את המידע האישי שתבחר לספק לנו, כמו פרטי الاتصال שלך („מידע חברתי“).בנוסף, חברות המארחות את הדפים החברתיים שלנו עשויות לספק לנו מידע מקובץ וניתוח על הפעילות החברתית שלנו.',
    subBlock5:
      'נתוני יומן (Log Data): מידע הנשלח אוטומטית על ידי הדפדפן שלך בזמן השימוש בשירותים שלנו. נתוני יומן כוללים את כתובת ה-IP (Internet Protocol) שלך, סוג והגדרות הדפדפן, תאריך ושעה של הבקשות שלך, ואופן האינטראקציה שלך עם אתר האינטרנט שלנו.',
    subBlock6:
      'נתוני שימוש: נוכל לאסוף אוטומטית מידע על השימוש שלך בשירות, כגון סוגי התוכן אותם אתה צופה או אינטראקטיבי איתו, התכונות שאתה משתמש בהן, הפעולות שאתה מבצע, כמו גם אזור הזמן שלך, מדינה, תאריך ושעה של גישה, גורם משתמש וגירסה, סוג המחשב או המכשיר הנייד, וחיבור המחשב שלך.',
    subBlock7:
      'מידע על המכשיר: התוכן כולל את שם המכשיר, מערכת ההפעלה, מזהה המכשיר והדפדפן שבו אתה משתמש. המידע שנאסף עשוי להיות תלוי בסוג המכשיר שבו אתה משתמש וההגדרות שלו.',
    subBlock8:
      'קוקיז: אנו משתמשים בקוקיז כדי להפעיל ולנהל את השירותים שלנו ולשפר את החוויה שלך. "קוקי" הוא מידע שנשלח על ידי אתר אינטרנט שביקרו בו לדפדפן שלך. אתה יכול להגדיר את הדפדפן שלך לקבל את כל הקוקיז, לדחות את כל הקוקיז, או להתריע לך כשהוגדר קוקי כדי שתוכל להחליט אם לקבל אותו בכל פעם. עם זאת, דחיית קוקיז עלולה למנוע ממך להשתמש או להשפיע לרעה על התצוגה או הפונקציונליות של אזורים או תכונות מסוימות של האתר. למידע נוסף על קוקיז, רשום בבקשה את אתר "All About Cookies".',
    subBlock9:
      'אנליטיקה: ייתכן ונשתמש במוצרים מגוונים של אנליטיקה מקוונת המשתמשים בקוקיז כדי לעזור לנו לנתח כיצד משתמשים משתמשים בשירותינו ולשפר את החוויה שלך בעת השימוש בשירותים.',
    subTitle1: 'מידע אישי שאנחנו אוספים',
    subTitle2: 'איך אנו משתמשים במידע אישי',
    subTitle3: 'פחתת מידע אישי',
    subTitle4: 'הזכויות שלך',
    subTitle5: 'קישורים לאתרים אחרים',
    subTitle6: 'אבטחה ושמירה של מידע',
    subTitle7: 'שינוי בדין הפרטיות',
    subTitle8: 'איך ליצור קשר איתנו',
    title: 'מדיניות פרטיות',
    updateTime: 'עודכן: 15 במרץ 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'קבל הכל',
    text: 'כדי לשפר את החוויה שלך, אנו משתמשים בקוקיז כדי להתאים אישית תוכן ושירותים.',
    title: 'אתר זה משתמש בקוקיס',
  },
  slogen: 'עזר ה-AI הקל ביותר',
  stripe: {
    contact: 'צור קשר μαζί μας ב- contact@noam.tools עם כל שאלה!',
    fail: {
      btn: 'נסה שוב',
      text1: 'לא הצלחנו לעבד את התשלום שלך.',
      text2: 'בדוק את החיבור שלך ונסה שוב.',
      title: 'התשלום נכשל',
    },
    succ: { btn: 'בוא נלך', text1: 'ברוכים הבאים לנועם,', text2: 'בואו נתחיל!', title: 'מזל טוב' },
  },
  terms: {
    block1: 'תודה ששימשת Noam!',
    block10:
      '(א) דמי וחשבונאות. תשלם את כל הדמי ("הדמי") בהתאם לתמחור והתנאים בדף התמחור הרלוונטי או כמאושר בצורה כתובה ביןنا. אנו שומרים לעצמנו את הזכות לתקן שגיאות או טעויות בתמחור גם אם שיצאנו חשבוניות או קיבלנו תשלום. תספק מידע מלא ומדויק לחשבונאות, כולל שיטת תשלום תקפה ומאושרת. אנו תטמין את שיטת התשלום שלך בנסיבות תקופתיות כמאושר, אך עשוי לשנות את תאריך החשבונא בצורה סבירה. אתה מתיר לנו, לפתחים שלנו ולמעבדי תשלומים של צד שלישי לטמין את שיטת התשלום שלך. אם התשלום שלך נכשל, נוכל לספק לך הודעה כתובה ולהישע את הגישה לשירות עד קבלת התשלום. למעט אם צוין אחרת בהסכמה זו, התשלומים אינם ניתן להחזרות.',
    block11:
      '(ב) מסות. אלא אם צוין אחרת, התשלומים אינם כוללים מסות פדרליות, מדינתיות, מקומיות או זרות, חובות ומימונים דומים ("מסות"). אתה אחראי לכל המסות הקשורות לרכישותיך, למעט מסות המבוססות על הרווח הנקי שלנו, שלהן נשלח לך חשבונית. אתה מסכים לשלם את המסות הללו בזמן קצר ולספק לנו הצהרות פרטיות חוקיות ולקבל הסכמות נדרשות לטיפול בנתונים כאלה, ואתປະກ斯曼 לנו שאתה מטפל בנתונים כאלה בהתאם לחוק החל.',
    block12:
      '(ג) שינויים במחירים. נוכל לשנות את המחירים על ידי הודעה לך דרך חשבונך ו/או את האתר האינטרנטי שלנו. עליות במחירים יכלו לתוצאות מיד עם פרסום. כל שינוי במחירים יחול על השערות עבור חשבונך לאחר תאריך вступления לתוקף השינוי.',
    block13:
      '(ד) מחלוקות ותשלומים מקושטים. אם אתה רוצה לטעון במחלוקת על שערים או מסים כלשהם, נא ליצור קשר עם contact@noam.tools תוך שלושים (30) ימים מיום החשבונית.',
    block14:
      '(ה) שימוש חופשי. אתה לא רשאי ליצור חשבונות מרובים כדי להשיג קרדיטים חופשיים. אם נקבע כי אתה לא משתמש בקרדיטים החופשיים במוסר טוב, נוכל לגבות ממך דמי סטנדרטיים או להפסיק לספק גישה לשירות.',
    block15:
      '(א) סודיות. ייתכן שיש לך גישה למידע סודי של נועם. אתה רשאי להשתמש במידע סודי רק כפי שמורשה במסגרת תנאים אלו למטרות שימוש בשירות. אתה לא רשאי לחשוף מידע סודי לצד שלישי כלשהו, ותשמור על מידע סודי בצורה לא פחות מגנה ממה שאתה משמר מידע סודי דומה משלך, לפחות בטיפול סביר. מידע סודי הוא מידע לא ציבורי המסומן כסודי על ידי נועם או שעליו להתייחס באופן סביר כסודי בהתנאים הנתונים, כולל תוכנה, מפרטים ומידע עסקי אחר לא ציבורי. מידע סודי לא כולל מידע ש: (1) הופך לזמין לציבור הכללי ללא שגיאה מצאתך; (2) היה ברשותך ללא כל חובה של סודיות לפני קבלתו במסגרת תנאים אלו; (3) הוחשף לך חוקית על ידי צד שלישי ללא כל חובות סודיות; או (4) פותח באופן עצמאי על ידך ללא שימוש במידע הסודי. אתה רשאי לחשוף מידע סודי אם נדרש לפי חוק, פסק דין או צו רשמי אחר, אך אתה חייב לספק הודעה כתובה מוקדמת לנועם בצורה סבירה, ובמידת האפשר, לבצע מאמצים סבירים להגביל את היקף ההחשפה, כולל סיוע לנו בהתנגדות לבקשות חשיפה.',
    block16:
      '(ב) אבטחה. אתה חייב ליישם אמצעים סבירים ומתאימים כדי לעזור להגן על הגישה והשימוש שלך בשירות. אם תגלה פגמים או הפותרות הקשורות לשימושך בשירות, אתה חייב לפנות לנועם בזמן רבוי ולספק פרטים על הפגם או ההפרה.',
    block17:
      '((ג) עיבוד נתונים אישיים. אם אתה משתמש בשירות לעיבוד נתונים אישיים, אתה חייב לספק הצהרות פרטיות מספקות משפטית ולקבל הסכמות נחוצות לעיבוד נתונים כאלה, ואת מצהר לנו שאתה מטפל בנתונים כאלה בהתאם לחוק החל.} ',
    block18:
      '(א) סיום; השעיה. התנאים הללו יחלו משלב השימוש הראשון שלך בשירות וישארו בתוקף עד לסימום. אתה можете לסיים את התנאים הללו בכל עת מכל סיבה על ידי הפסקת השימוש בשירות ובתוכן. אנו רשאים לסיים את התנאים הללו עם התראה מוקדמת מכל סיבה. אנו רשאים לסיים את התנאים הללו באופן מיידי על ידי התראה לך אם אתה מפר באופן מהותי סעיף 2 (דרישות השימוש), סעיף 5 (סודיות, אבטחה وحماية נתונים), סעיף 8 (פתרון מחלוקות) או סעיף 9 (תנאים כלליים), או אם היחסים שלנו עם ספק טכנולוגיה של צד שלישי מחוץ לשליטתנו משתנים, או עבור ציות לחוק או לבקשות ממשלתיות. אנו רשאים להפעיל את גישה לשירות אם אתה לא מציית לתנאים הללו, או אם השימוש שלך מהווה סיכון אבטחה עבורנו או עבור צד שלישי כלשהו, או אם אנו חושדים שהשימוש שלך מרוב מרי או עלול לחשוף אותנו או צד שלישי כלשהו לחובות משפטיות.',
    block19:
      '(ב) השפעות הפרישה. עם הפרישה, תפסיק להשתמש בשירות ותחזיר או תשמיד בדחיפות כל מידע סודי כפי שנורד על ידינו. הוראות התנאים הללו שהטבעם דורש שהן יישארו בתוקף לאחר הפרישה או הגמר התוקף, כולל אך לא περιοricted לסעיפים 3 ו-5-9, יישארו בתוקף.',
    block2:
      'תנאי השימוש הללו חלים על השימוש שלך בשירותי נועם, לרבות ממשקי תכנות יישום, תוכנות, כלים, שירותי מפתחים, נתונים, תיעוד ואתר אינטרנט שלנו (מעורבים יחד כהשירותים")". על ידי השימוש בשירותינו, אתה מסכים לציית לתנאים אלו. מדיניות הפרטיות שלנו מסבירה כיצד אנו אוספים ומשתמשים במידע אישי.',
    block20:
      'ביטול אחריות. תגן, תבטל אחריות ותשמור אותנו, חברות השייכות שלנו ואנשי הצוות שלנו בטוחים מפני כל תביעות, הפסדים והוצאות (כולל שכרו של עורכי דין) הנובעים משימושך בשירות, או הקשורים אליו, כולל התוכן שלך, שימושך במוצרים או שירותים הקשורים לשירות, והפרה שלך של תנאים אלו או חוק תקף.',
    block21:
      '(ב) סירוב אחריות. השירות מסופק "כפי שהוא". במידת המקובלת על פי החוק, אנחנו וחברות השותפות והמעניקים הרשום שלנו לא מתנו כל ייצוג או ضمان של כל סוג לגבי השירות ולא מניחים שום ضمانים, לרבות ללא הגבלה ضمانי סחיריות, התאמה למטרות ספציפיות, איכות משתנה, אי הפרה ושימוש נקי, וכל ضمان הנובע משיטת העסקים או שימוש בסחר. איננו מניחים שהשירות יהיה ללא הפרעות, מדויק או ללא שגיאות, או שהתוכן כלשהו יהיה בטוח, לא יאבד או לא ישתנה.',
    block22:
      '(ג) הגבלת אחריות. לא נוכל, חברות השייכות שלנו או המעניקים הסיכה שלנו יהיו אחראים לנזקים עקיפים, מקריים, מיוחדים, תוצאביים או עונשים, כולל אובדן רווחים, אובדן מוניטין, אובדן שימוש, אובדן נתונים או אובדנים אחרים בלתי ממושכים, אפילו אם הודענו על האפשרות של נזקים כאלה. לפי התנאים הללו, האחריות הכוללת שלנו לא תעלה על הסכום ששילמת לשירות במהלך שנים עשר (12) החודשים שלפני התביעה או מאה דולר ארה"ב ($100), לפי מה שגדול יותר. ההגבלות בסעיף זה חלות במידת המקסימלית המאומנת על ידי התוקף החקתי.',
    block23:
      'התנאים והשימוש שלך בשירותים נשלטים על ידי חוקי ארצות הברית, למעט כללי התנגשות החוקים האמריקניים. השימוש שלך באפליקציה עשוי להיות גם כפוף לחוקים מקומיים, מדיניים, לאומיים או בינלאומיים אחרים. כל פעולה משפטית או הליך הקשור לתנאים אלו יוביאו אך ורק בבתי המשפט של ארצות הברית, ואתה מסכים להסמכה לרישום אישי של בתי משפט כאלה.',
    block24:
      'מערכת היחסים בין הצדדים. נועם ואתה מהווים קבלני עצמאיים, ואין לשום צד סמכות לייצג או לקשור את הצד השני או לקבל אחריות עבור הצד השני ללא הסכמה כתובה מוקדמת של הצד השני.',
    block25:
      '(ב) שימוש במותג. לא תשתמשו בשם, לוגו או סימני מסחר של נועם או כל משותף משלו ללא הסכמה כתובה מוקדמת שלנו.',
    block26:
      'אם כל סעיף במתני תנאים אלו יאומת כלא חוקי, בלתי חוקי או בלתי ניתן לביצועה, הסעיפים הנותרים יישארו בתוקף מלא ופעילים.',
    block3:
      'אם אתה מתחת לגיל 18 שנים, אתה חייב להשיג אישור מהורים או הוועדים משפטיים שלך כדי להשתמש בשירות. אם אתה משתמש בשירות בטענת אדם או ישות אחרת, אתה חייב להיות מורשה לקבל את התנאים הללו בטענתם. אתה חייב לספק מידע מדויק ומלא כדי להרשם לחשבון. אסור לך לספק את אישורי הגישה או החשבון שלך למישהו מחוץ לארגון שלך, ואתה אחראי לכל הפעילות המתבצעת באמצעות אישורי הגישה שלך.',
    block4:
      '(א) שימוש בשירות. אתה רשאי לגשת לשירות על פי תנאים אלו, ואנחנו מעניקים לך זכות לא בלעדי להשתמש בשירות. בעת השימוש בשירות, תשתף בשימוש עם תנאים אלו וכל החוקים החלים. אנחנו ושותפים שלנו מרישיים לכל הזכויות, השמות והאינטרסים בשירות.',
    block5:
      '(ב) משוב. אנו מקבלים בברכה משוב, תגובות, רעיונות, הצעות והשתפרות. אם אתה מספק תוכן כזה, נוכל להשתמש בו ללא כל הגבלות וללא פיצוי לך.',
    block6:
      '(ג) הגבלות. אתה לא רשאי: (1) להשתמש בשירות באופן המפרה, חוצה או מפר זכויות אחרים; (2) לבצע הנדסה הפוכה, לפעל דקומפילציה, לפרק, לתרגם או לנסות בדרך אחרת לגלות את הקוד המקורי או המרכיבים הבסיסיים של מודלים, אלגוריתמים ומערכות של השירות (אלא אם הגבלות כאלו נחסמות על ידי חוק רשום); (3) להשתמש בתוצאות השירות כדי לפתח מודלים המתחרים על נועם; (4) לחלץ נתונים או תוצאות מהשירות באמצעות שיטות אוטומטיות או תכנותיות כלשהן אלא אם כן מותר באמצעות ה-API, לרבות סקריפинг, גמילה מאינטרנט או חילוץ נתונים מאינטרנט; (5) להציג את תוצאות השירות כנוצרות באופן מלאכותי כאשר הן לא ככזה, או להפר בדרך אחרת את מדיניות השימוש שלנו; (6) לקנות, למכור או להעביר מפתחות API ללא הסכמתנו מוקדמת; או (7) לספק לנו מידע אישי כלשהו של ילדים מתחת לגיל 13 או גיל הוויתור דיגיטלי הרשום. תתעלם עם כל מגבלות קצב ודרישות אחרות בתיעוד שלנו.',
    block7:
      '(ד) שירותים של צדדים שלישיים. כל תוכנה של צדדים שלישיים, שירותים או מוצרים אחרים הקשורים לשירות נשלטים על ידי התנאים שלהם, ואנחנו לא אחראים למוצרים של צדדים שלישיים.',
    block8:
      'התוכן שלך. אתה רשאי לספק קלט ("Input") לשירות ולקבל פלט ("Output") שנוצר ונחזר על סמך הקלט (מחובר בשם "Content"). בין הצדדים, ובמידת שהוקם על ידי חוק חל, אתה בעל כל הקלט. נועם רשאי להשתמש בתוכן כדי לספק ולשמור על השירות, לעמוד בחוקים חלים ולאכוף את הפוליסיאות שלנו. אתה אחראי על התוכן, כולל ضمانו שהוא לא מפר כל חוק חל או תנאים אלו.',
    block9:
      '(ב) טוהר. בינה מלאכותית ומיקוד מכונה הן תחומות מחקר המתפתחות במהירות. אנו מניחים מאמצים מתמדים לשפר את השירות שלנו כדי להפוך אותו ליותר מדויק, אמין, בטוח ומועיל. לאור האופי הסיכום של מיקוד המכונה, שימוש בשירות שלנו עלול לגרום לפלטי שגיאה במקרים מסוימים, שאינם משיגים בצורה מדויקת פרטים אמיתיים על אנשים, מקומות או حقائق. עליך להעריך בצורה מתאימה את טוהר כל פלט בהתאם למקרה השימוש שלך, כולל באמצעות בדיקה ידנית של הפלטים.',
    subTitle1: 'רישום וגישה',
    subTitle10: 'נפרדות',
    subTitle2: 'דרישות שימוש',
    subTitle3: 'תוכן',
    subTitle4: 'עמלות ותשלום',
    subTitle5: 'ביטחון סודיות, אבטחה והגנה על נתונים',
    subTitle6: 'תקופה והפסקה',
    subTitle7: 'פטרון אחריות; מיקוטים; הגבלת אחריות',
    subTitle8: 'חוק השולט וסמכות שיפוטית',
    subTitle9: 'תנאים כלליים',
    title: 'תנאי שימוש',
    updateTime: 'עודכן: 15 במרץ 2024',
  },
  trialModal: {
    btn: 'התחל עכשיו (רק 0.99$)',
    chat: 'ChatPDF',
    desc1: 'לאחר תקופת הניסיון, תחובה לשלם שער שנתי של 180 דולר',
    desc2: 'בטל בכל עת',
    focus: 'התמקדות',
    hover: 'תרגום מעוף',
    image: 'תרגום תמונה',
    installBtn: 'התקן עכשיו כדי לקבל את המתנה שלך',
    memo: 'ניהול מועדפים',
    pdf: 'תרגום מקביל של PDF',
    realtime: 'תרגום מיידי',
    select: 'תרגום בחירת מילים',
    title: 'מתנה של ברוכים הבאים',
    trialText: 'ניסוי של 7 ימים',
    video: 'תרגום וידאו',
    videoSummary: 'סיכום וידאו',
    web: 'תרגום מקביל',
    webSummary: 'סיכום אינטרנטי',
  },
  upgradeModal: {
    btn: 'שדרג עכשיו',
    chat: { free: 'הגעתם למגבלת ChatPDF', pro: 'הגעתם למגבלה של ChatPDF לחודש זה' },
    contactStr: 'נא להמתין לאיפוס הבא, או ליצור קשר μαζί μας בכתובת contact@noam.tools.',
    limitAlertStr: 'הגעתם למגבלת תוכנית החינם שלכם. שדרגו כדי להמשיך.',
    more: 'הצג תוכניות',
    pageLimit: { free: 'הגעתם למגבלת עמודים של PDF' },
    title: 'תזכורת',
    upgradeAlertStr: 'הגעתם למגבלת התוכנית החינמית שלכם. שדרגו כדי להמשיך.',
    upload: {
      free: 'הגעתם למגבלת התרגום ל-PDF שלכם',
      pro: 'הגעתם למגבלת התרגום של PDF עבור החודש זה',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'הצטרפו עכשיו',
      label: 'יתרונות למשתמשים חדשים:',
      remain: 'רק 30 נותרו',
      text: 'רק 100 מקומות פנויים! תפס את שלך עכשיו!',
    },
  },
  aiPdfTranslator: {
    title: 'מתקבל תרגום PDF AI בחינם: מתרגם PDF עם השוואה בכל שפות',
    desc: 'תרגם בקלות קבצי PDF לכל שפה עם AI. השווה בין הטקסט המקורי למתורגם זה לצד זה, במהירות וללא תשלום.',
    keywords: 'GPT-4、עוזר AI、תרגום、סיכום、פוקוס、ChatPDF、ממונו、יעילות',
    sourceToTarget: {
      title: 'כלים חינכיים לתרגום PDF: מתרגמים {{source}} ל-{{target}} בחינם',
      desc: 'תרגמו את קבצי ה-PDF שלכם משפה מקורית כלשהי לשפה המועדפת עבורכם בחינם. תרגום PDF מהיר, מדויק ומאובטח המופעל על ידי AI מתקדם.',
    },
    headerIntroduce: {
      title: 'נועם: יותר ממיקוד מקווני פשוט',
      introduce1: {
        title: 'נועם · קורא PDF',
        desc: '✨תרגום צמוד + שאלות ותשובות AI. מתרגמים קבצי PDF במהירות ודיוק לשפה המטרה שלך. שואלים בחופשיות שאלות על התוכן כדי להשיג הבנה עמוקה יותר של קבצי ה-PDF שלך.',
      },
      introduce2: {
        title: 'נועם · הרחבת תרגום צד בצד',
        desc: '👏פתור את כל צרכי התרגום של אתר האינטרנט שלך:',
        detail1: { title: 'תרגום דף אינטרנט:', desc: 'תצוגה דו-לשונית צד בצד' },
        detail2: { title: 'תרגום מילה:', desc: 'תרגום מהיר בקיצור יד' },
        detail3: { title: 'תרגום מיידי:', desc: 'תרגם מילים או משפטים באופן מיידי.' },
        detail4: { title: 'תרגום תמונה:', desc: 'החלף תמונות במועברות תרגום.' },
        detail5: { title: 'תרגום וידאו:', desc: 'כיתובי טקסט דו-לשוניים לשיפור צפייה טובה יותר.' },
        footer: 'חוו יותר תכונות קריאה ממוקדות ב-AI לתרגום חכם יותר!',
      },
    },
    subtitle: 'תרגום PDF מקוון בחינם',
    introduce: {
      module1: {
        detail1: {
          title: 'תרגום PDF בזמן אמת זה לצד זה',
          desc1: 'הצג מיד תוכן מקורי ומותאם מרוב בפריסה מסונכרנת וצדדי צד',
          desc2: 'השוו את שתי הגירסאות בקלות עם גלילה מסונכרנת',
          desc3: 'שמור על פורמט זהה לניסיון קריאה עקבי',
        },
        detail2: {
          title: 'יישור ואימות מדויק של תוכן',
          desc1: 'יישור מושלם בין הטקסט המקורי למתורגם לצורך επαλήθευση קלה',
          desc2: 'כל קטע תוכן תואם בדיוק בין שתי הגרסאות',
          desc3: 'זיהוי ופתרון מהירים של אי התאמות בתרגום לקבלת תוצאות אמינות',
        },
      },
      module2: {
        detail1: {
          title: 'מודלים מרובים מתקדמים של בינה מלאכותית לתרגום מדויק',
          desc1: 'בחר ממודלים מובילים של AI כדי להתאים לדרישות התרגום שלך',
          desc2: 'הבטיח תוצאות אופטימליות עבור סוגים שונים של מסמכים ותעשיות',
          desc3: 'אפשרויות מודלים גמישות מספקות פתרונות מותאמים אישית לכל סצנריה',
        },
        detail2: {
          title: 'תרגום AI מתקדם לכל סוג תוכן',
          desc1: 'המודל התוכנה המאומץ שלנו בבינה מלאכותית гарантирует דיוק גבוה והבנת שפה טבעית',
          desc2: 'מטמיע מסמכים טכניים, אקדמיים וחזותיים בקלות',
          desc3: 'מספק תוצאות אמינות לכל הצרכים שלך בתרגום',
          desc4: 'התאמה אינטליגנטית לסוגי תוכן שונים להצגת ביצועים אופטימליים',
        },
      },
      module3: {
        detail1: {
          title: 'אינטראקציה אינטליגנטית עם מסמכים',
          desc1: "צ'אט בלי מאמץ עם קבצי PDF ופרזנטציות שלך באמצעות AI מתקדם",
          desc2: 'שאל מיד שאלות על תוכן המסמך וקבל תשובות מדויקות',
          desc3: 'צור במהירות סיכומים תמציתיים למסמכים ארוכים',
        },
        detail2: {
          title: 'ניתוח תוכן עמוק ואינטגרציה חלקה',
          desc1: 'חלץ מידע מפתח ונתח נתונים מורכבים עם הבנה ממוקדת בינה מלאכותית',
          desc2: 'הצגת תובנות על חומרים טכניים, אקדמיים או יצירתיים',
          desc3: 'משתלב חלקן עם מתרגם ה-PDF שלנו עבור פתרון מלא לניהול מסמכים',
        },
      },
      module4: {
        detail1: {
          title: 'מעבר לתרגום PDF: פתרון תרגום אתרי אינטרנט משולב',
          desc: 'גלו את הרחבת התרגום התוחמת והחזקה שלנו, שתוכננה לכל תרחיש קריאה מקוונת.',
          desc1: 'תרגום דף אינטרנט: ליהנות מתכנים דו-לשוניים עם תצוגה מתואמת צד בצד',
          desc2: 'תרגום מילים: תרגם מילים מודגשות באופן מיידי בלחיצה אחת',
          desc3: 'תרגום מיידי: תעתיק כל טקסט או משפט בזמן אמת להבנה מהירה',
          desc4: 'תרגום תמונה: החלף אוטומטית תמונות מקוריות בגרסאות מתורגמות',
          desc5: 'תרגום וידאו: צפו בסרטונים עם כתוביות דו-לשוניות לחוויה משופרת',
        },
      },
    },
    question: {
      title: 'שאלות נפוצות',
      answer1: {
        title: 'האם מתורגמן ה-PDF של נועם חינמי לשימוש לתרגום PDF?',
        content:
          'כן, אתה יכול לתרגם PDF למספר חינם עם Sider PDF Translator! אנו מציעים מגבלת חינם של 5,000 טוקנים, שהיא מספקת לתרגום רוב מסמכי ה-PDF הנפוצים בשוק. אם אתה צריך לתרגם קבצים גדולים יותר או זקוק לפונקציות מתקדמות, אתה יכול לבחור לשדרג לתוכניות הפרימיום שלנו לקבלת יכולות נוספות עוד יותר.',
      },
      answer2: {
        title: 'כמה מדויק מתורגמן ה-PDF של נועם?',
        content:
          'מתרגם ה-PDF של נועם מספק תרגומים מדויקים ביותר על ידי שימוש בטכנולוגיית AI מתקדמת והבנת עמוקה בהקשר של המסמכים שלך. אמנם לא מתרגם אוטומטי ללא פגמים, אך התצוגה הצדדיة שלנו מאפשרת לך לסקור ולשפר בקלות כל תרגום, מה שמבטיח שהתוצאה הסופית עומדת לציפיות האיכות שלך. تجربة תרגום PDF אמין ומדויק עם נועם.',
      },
      answer3: {
        title: 'האם μπορώ לתרגם PDF מסרוקים?',
        content:
          'כן, אתה יכול לתרגם PDF מסרוקים באמצעות טכנולוגיית OCR (זיהוי תווים אופטי) מובנית במערכת שלנו. המערכת שלנוИзвлекает אוטומטית טקסט מסמכים מסרוקים ו-PDF מבוססי תמונה, ואז מתרגמת את התכנים עבורך. זה מבטיח שניתן לתרגם במדויק אפילו PDF לא ניתנים לעריכה או המבוססים רק על תמונות.',
      },
      answer4: {
        title: 'כמה זמן לוקח תרגום?',
        content:
          "התרגום מהיר ויעיל—רוב המסמכים מעובדים תוך שניות עד דקות ספורות, בהתאם לאורכם ולמורכבותיהם. למשל, PDF סטנדרטי בן 10 עמודים בדרך כלל לוקח פחות משנ' דקות לתרגום. תהנו מזמני תשובה מהירים לכל צרכי התרגום של המסמכים שלכם!",
      },
      answer5: {
        title: 'האם μπορώ לשמור על תצוגה צדדי לצד לקריאה?',
        content:
          'כן, אתה תמיד יכול לקרוא את המסמכים שלך בצד לצד. תצורה זו מאפשרת לך להשוות את התוכן המקורי והתורגם בקלות, ומבטיחה חווית קריאה חלקה ויעילה.',
      },
    },
    freeTrial: 'ניסיון חינם',
    toLanguage: { title: 'זוגות תרגום AI ל-PDF', item: '{{מקור}} ל-{{יעד}}' },
  },
  aiPdfTranslate: {
    header: {
      pricing: 'מחירון',
      blog: 'בלוג',
      features: 'מאפיינים',
      button: 'תרגם עכשיו',
      faq: 'שאלות ותשובות נפוצות',
    },
    hero: {
      upload: {
        title: 'העלה את ה-PDF שלך',
        highlight: 'לחץ כדי לדפדף',
        max: 'מקס',
        desc: 'או גרר והפעל',
      },
      to: 'ל',
      title: 'מתקבל PDF חופשי',
      pill: 'מתורגמן PDF מופעל על ידי AI',
      model: 'GPT-4 ו-Claude',
      desc: 'תרגומים מיידיים ודיוקים המשמרים את הפריסה המקורית. Noam AI תומך בזיהוי תמונה לטקסט (OCR) ותצוגות צד בצד.',
      free: 'ניסוי חינם',
      support: 'תמיכה ב-OCR',
      complete: 'תרגום הושלם',
      translated: 'תורגם על ידי נועם',
    },
    ticker: {
      pdf: 'תרגום PDF',
      ocr: 'טכנולוגיית OCR',
      format: 'שמירה על פורמט',
      multi: 'שיטות שפות מרובות',
      side: 'יחד בצד',
      chat: 'שיחה עם PDF',
      web: 'תרגום אינטרנטי',
      secure: 'בטוח ופרטי',
    },
    comparison: {
      bad: {
        title: 'תרגום סטנדרטי',
        head: 'פורמט וקשר אבודים',
        text1: 'שגיאה: פריסה שבורה. תמונות ממוקמות שגויה.',
        text2: 'הטקסט חופף וגופני הטקסט אינם עקביים. קשה לקריאה ולא מקצועי...',
      },
      dump: { title: 'צפיית טקסט רגיל' },
      good: { title: 'תרגום AI נועם', sub: 'עיצוב מושלם, מודע לפריסה', tag: 'תוצאה מושלמת' },
      title: 'למה לבחור את Noam AI?',
      desc: 'הפסיקו להתמודד עם תרגום העתקה-הדבקה. חוו את ההבדל בין כלי סטנדרטיים לתרגום מודעה לפריסה ממוקד ב-AI שלנו.',
    },
    showcase: {
      title1: 'כל מסמך',
      kicker: 'מסמכים נתמכים',
      carousel1: 'אמנות',
      title2: 'כל שפה',
      carousel2: 'ארכיטקטורה',
      note: 'ניהול מסמכים טכניים, אקדמיים ויצרניים בנחות',
      carousel3: 'כתב עמידה אקדמי',
      carousel5: 'פיננסים',
      carousel6: 'חוק',
      carousel4: 'רפואה',
      carousel7: 'חוזה',
      carousel8: 'מדיניות',
    },
    features: {
      big: {
        title: 'מודלים מתקדמים של AI (GPT-4, Claude)',
        desc: 'בחר ממדלים מובילים של AI כדי להתאים לדרישות התרגום שלך. ודא תוצאות אופטימליות עבור סוגים שונים של מסמכים.',
      },
      grid1: { title: 'תמיכה ב-OCR', desc: 'חלץ ותרגם טקסט מ-PDF מסרוקים ותמונות באופן מיידי.' },
      grid2: {
        title: 'ייצוא רזולוציה גבוהה',
        desc: 'הורד את המסמכים המתורגמים שלך בפורמט PDF עם הפריסה המקורית.',
      },
      grid3: { title: 'השוואה צד בצד', desc: 'גלילה מתואמת להשוואת טקסט מקורי ומותאם' },
      title1: 'יותר משפירוט',
      title2: 'זה מהפכה',
      line1: 'מאמר טכני.pdf',
      line2: 'זיהוי שפה: אנגלית...',
      line3: 'מודל: GPT-4o (דיוק גבוה)',
      line4: 'תרגום הושלם (דיוק 99%)',
    },
    testimonials: {
      review1: {
        role: 'חוקר',
        content:
          'נואם איי.איי חיסך לי שעות בתרגום של מאמרים אקדמיים. התצוגה לצד לצד היא מעילה לעזר באימות מונחים טכניים.',
      },
      review2: {
        role: 'מַשְׁלִיט שַׁעֲרִי גְלוֹבָלי',
        content:
          'המתרגם PDF הטוב ביותר ששיממשתי בו. הוא שומר את הפורמט המקורי בצורה מושלמת, וזה חיוני עבור מערכות השיווק שלנו.',
      },
      review3: {
        role: 'יועץ משפטי',
        content:
          'מדויק ומהיר. אני משתמש בו לתרגומי חוזים ותכונת ה-OCR עבור מסמכים מסרוקים עובדת בצורה ללא תקלות.',
      },
      kicker: 'נאהב על ידי משתמשים',
      title: 'מה אומרים המשתמשים שלנו',
    },
    cta: {
      title: 'מוכנים לשבור حواجز שפה?',
      button: 'התחל לתרגם בחינם',
      desc: 'הצטרפו ל-10,000+ משתמשים והתחילו לתרגם את המסמכים שלכם עם Noam AI היום.',
      hint: 'תרגם את התוכן הבא לעברית מקומית:',
    },
    languagePairs: {
      title: 'זוגות תרגום AI של PDF אנגליים',
      desc: 'כיווני תרגום פופולריים הנתמכים על ידי Noam AI',
    },
    footer: { about: 'עלינו', privacy: 'מדיניות פרטיות', contact: 'צור קשר עם התמיכה' },
  },
}

export default TRANSLATION
